var ReportExportFormatter = {
    reportsToPAXML: function(reports, users) {
        // PAXML Documentation can be found in gDrive
        // "If developers were smart, they would use xml for everything" - Powerpoint slide from Uppsala University 2017
        var xmlDoc = document.implementation.createDocument(null, "paxml");
        var rootElements = xmlDoc.getElementsByTagName("paxml");

        var attr1 = xmlDoc.createAttribute("xmlns:xsi");
        attr1.value = "http://www.w3.org/2001/XMLSchema-instance";

        var attr2 = xmlDoc.createAttribute("xsi:noNamespaceSchemaLocation");
        attr2.value = "http://www.paxml.se/2.0/paxml.xsd";

        if (rootElements != null && rootElements.length > 0 && rootElements[0] != null) {
            rootElements[0].setAttributeNode(attr1);
            rootElements[0].setAttributeNode(attr2);
        }

        // Headers
        var headers = xmlDoc.createElement("header");

        var format = xmlDoc.createElement("format");
        var version = xmlDoc.createElement("version");
        //var datum           = xmlDoc.createElement("datum");
        var programnamn = xmlDoc.createElement("programnamn");

        this.addTextToElement(xmlDoc, format, "LÖNIN");
        this.addTextToElement(xmlDoc, version, "2.0");
        //this.addTextToElement(xmlDoc, datum, Formatting.date(new Date(), false));
        this.addTextToElement(xmlDoc, programnamn, "Coredination");

        this.addChildrenToElement(headers, [format, version, programnamn]);
        rootElements[0].appendChild(headers);

        // TimeTransactions
        var tidtransaktioner = xmlDoc.createElement("tidtransaktioner");
        var self = this;
        reports.forEach(function(report){
            if (report && report.get('items') && report.get('items').length > 0) {
                var items = report.get('items');
                items.forEach(function(item) {
                    if (item && item.unit && item.unit != "HOURS") return;
                    tidtransaktioner.appendChild(self.itemToPAXMLTimeTransaction(report, item, users, xmlDoc));
                });
            } else {
                tidtransaktioner.appendChild(self.reportToPAXMLTimeTransaction(report, users, xmlDoc));
            }
        });
        /*
        for (var i = 0; i < reports.length; i++) {
            tidtransaktioner.appendChild(this.reportToPAXMLTimeTransaction(reports[i], users, xmlDoc));
        }
        */
        rootElements[0].appendChild(tidtransaktioner);

        return xmlDoc;
    },

    itemToPAXMLTimeTransaction: function(report, item, users, xmlDoc) {
        var user = null;
        if (report.toJSON) {
            report = report.toJSON();
        }
        for (var i = 0; i < users.length; i++) {
            if (users[i].id == report.userId) {
                user = users[i];
            }
        }
        if (!user)
            throw i18next.t('errorMissingUser') + report.id

        // --- So that it works in both Diamant portal and Coredination ---
        if (user.toJSON) {
            user = user.toJSON();
        }
        // ----------------------------------------------------------------
        var self = this;
        var tidtrans = xmlDoc.createElement("tidtrans");
        if (user && user.personalIdentificationNo) {
            if (user.personalIdentificationNo.length < 12 || user.personalIdentificationNo.length > 12) {
                if (user.personalIdentificationNo.indexOf("-") > 0) {
                    user.personalIdentificationNo = user.personalIdentificationNo.replace("-", "");
                } else {
                    throw i18next.t('errorInvalidId') + user.fullName + i18next.t('errorInvalidId2');
                }
            }
            tidtrans.setAttribute("persnr", user.personalIdentificationNo);
        } else if (user) {
            throw i18next.t('errorMissingId') + user.fullName;
        } else {
            throw i18next.t('errorMissingUser')
        }
        if (report.workDate) {
            var datum = xmlDoc.createElement("datum");
            self.addTextToElement(xmlDoc, datum, Formatting.datePart(new Date(report.workDate), false));
            tidtrans.appendChild(datum)
        } else if (report.startTime && report.endTime) {
            var startTime = new Date(report.startTime);
            var endTime = new Date(report.endTime);
            var startDate = new Date(report.workDate)
            var endDate = startDate.clone();
            if (startTime > endTime){
                endDate.setDate(endDate.getDate() + 1);
            }
            var start = xmlDoc.createElement("starttid");
            self.addTextToElement(xmlDoc, start, Formatting.datePart(startDate, true) + "T" + Formatting.time(startTime, true));
            tidtrans.appendChild(start);
            var end = xmlDoc.createElement("sluttid");
            self.addTextToElement(xmlDoc, end, Formatting.datePart(endDate, true) + "T" + Formatting.time(endTime, true));
            tidtrans.appendChild(end);
        }

        var hours = 0.0;
        if (item && item.amount && (item.workHours || item.addOn) && item.unit && item.unit == 'HOURS') hours = item.amount;
        var timmar = xmlDoc.createElement("timmar");
        self.addTextToElement(xmlDoc, timmar, hours);
        tidtrans.appendChild(timmar);
        var tidkod = xmlDoc.createElement("tidkod");
        self.addTextToElement(xmlDoc, tidkod, self.productToPAXMLTimeCode(item.articleNo));
        tidtrans.appendChild(tidkod);

        return tidtrans;
    },

    reportToPAXMLTimeTransaction: function(report, users, xmlDoc) {
        console.log("report", report)
        var user = null;
        if (report.toJSON) {
            report = report.toJSON();
        }
        for (var i = 0; i < users.length; i++) {
            if (users[i].id == report.userId) {
                user = users[i];
            }
        }
        if (!user)
            throw i18next.t('errorMissingUser') + report.id

        // --- So that it works in both Diamant portal and Coredination ---
        if (user.toJSON) {
            user = user.toJSON();
        }
        // ----------------------------------------------------------------
        var tidtrans = xmlDoc.createElement("tidtrans");
        if (user && user.personalIdentificationNo) {
            if (user.personalIdentificationNo.length < 12 || user.personalIdentificationNo.length > 12) {
                if (user.personalIdentificationNo.indexOf("-") > 0) {
                    user.personalIdentificationNo = user.personalIdentificationNo.replace("-", "");
                } else {
                    throw i18next.t('errorInvalidId') + user.fullName + i18next.t('errorInvalidId2');
                }
            }
            tidtrans.setAttribute("persnr", user.personalIdentificationNo);
        } else if (user) {
            throw i18next.t('errorMissingId') + user.fullName;
        } else {
            throw i18next.t('errorMissingUser')
        }
        if (report.workDate) {
            var datum = xmlDoc.createElement("datum");
            this.addTextToElement(xmlDoc, datum, Formatting.datePart(new Date(report.workDate), false));
            tidtrans.appendChild(datum)
        }

        if (report.startTime && report.endTime) {
            var startTime = new Date(report.startTime);
            var endTime = new Date(report.endTime);
            var startDate = new Date(report.workDate);
            var endDate = startDate.clone();
            if (startTime > endTime){
                endDate.setDate(endDate.getDate() + 1);
            }

            var start = xmlDoc.createElement("starttid");
            this.addTextToElement(xmlDoc, start, Formatting.datePart(startDate, true) + "T" + Formatting.time(startTime, true));
            tidtrans.appendChild(start);
            var end = xmlDoc.createElement("sluttid");
            this.addTextToElement(xmlDoc, end, Formatting.datePart(endDate, true) + "T" + Formatting.time(endTime, true));
            tidtrans.appendChild(end);
        }

        if (report.workDuration) {
            var timmar = xmlDoc.createElement("timmar");
            this.addTextToElement(xmlDoc, timmar, Formatting.duration(report.workDuration).toString().replace(":", "."));
            tidtrans.appendChild(timmar);
        } else if (report.items && report.items.length > 0){
            var totalHours = 0.0;
            report.items.forEach(function(item) {
                if (item.amount && item.workHours && item.unit && item.unit == 'HOURS') totalHours += item.amount;
            });
            var timmar = xmlDoc.createElement("timmar");
            this.addTextToElement(xmlDoc, timmar, totalHours);
            tidtrans.appendChild(timmar);
        }

        if (report.type && report.type === "ABSENCE") {
            var tidkod = xmlDoc.createElement("tidkod");
            this.addTextToElement(xmlDoc, tidkod, this.acitivtyToPAXMLTimeCode(report.activityCode ? report.activityCode : report.activityName));
            tidtrans.appendChild(tidkod);
        } else {
            var tidkod = xmlDoc.createElement("tidkod");
            this.addTextToElement(xmlDoc, tidkod, "TID");
            tidtrans.appendChild(tidkod);
        }

        return tidtrans;
    },

    productToPAXMLTimeCode: function(articleNo) {
        if (!articleNo)
            return "TID";
        switch(articleNo.toLowerCase()) {
            case "arbetstid":
                return "TID";
            case "beredskapstid":
            case "be1":
                return "BE1";
            case "be2":
                return "BE2";
            case "be3":
                return "BE3";
            case "flextid":
            case "flx":
            case "flextid +/-":
                return "FLX";
            case "helglön":
            case "hlg":
                return "HLG";
            case "jourtid":
            case "jr1":
                return "JR1";
            case "jr2":
                return "JR2";
            case "jr3":
                return "JR3";
            case "lönetillägg övrigt":
            case "lt1":
                return "LT1";
            case "lt2":
                return "LT2";
            case "lt3":
                return "LT3";
            case "lt4":
                return "LT4";
            case "lt5":
                return "LT5";
            case "lt6":
                return "LT6";
            case "lt7":
                return "LT7";
            case "lt8":
                return "LT8";
            case "lt9":
                return "LT9";
            case "mertid":
            case "mer":
                return "MER";
            case "närvaro övrigt":
            case "nv1":
                return "NV1";
            case "nv2":
                return "NV2";
            case "nv3":
                return "NV3";
            case "nv4":
                return "NV4";
            case "nv5":
                return "NV5";
            case "nv6":
                return "NV6";
            case "nv7":
                return "NV7";
            case "nv8":
                return "NV8";
            case "nv9":
                return "NV9";
            case "ob-ersättning":
            case "ob1":
                return "OB1";
            case "ob2":
                return "OB2";
            case "ob3":
                return "OB3";
            case "ob4":
                return "OB4";
            case "ob5":
                return "OB5";
            case "os1":
                return "OS1";
            case "os2":
                return "OS2";
            case "os3":
                return "OS3";
            case "os4":
                return "OS4";
            case "os5":
                return "OS5";
            case "övertid":
            case "öt1":
            case "övertid 1 - betalning":
                return "ÖT1";
            case "öt2":
                return "ÖT2";
            case "öt3":
                return "ÖT3";
            case "öt4":
                return "ÖT4";
            case "öt5":
                return "ÖT5";
            case "ök1":
                return "ÖK1";
            case "ök2":
                return "ÖK2";
            case "ök3":
                return "ÖK3";
            case "ök4":
                return "ÖK4";
            case "ök5":
                return "ÖK5";    
            case "restid":
            case "re1":
                return "RE1";
            case "re2":
                return "RE2";
            case "re3":
                return "RE3";
            case "schematid":
            case "sch":
                return "SCH";
            case "skifttillägg":
            case "ski":
                return "SKI";
            case "tidssaldo":
            case "ts1":
                return "TS1";
            case "ts2":
                return "TS2";
            case "ts3":
                return "TS3";
            case "ts4":
                return "TS4";
            case "ts5":
                return "TS5";
            case "ts5":
                return "TS5";
            case "ts6":
                return "TS6";
            case "ts7":
                return "TS7";
            case "ts8":
                return "TS8";
            case "ts9":
                return "TS9";
            case "timlön":
            case "arb":
                return "ARB";
            default:
                return "TID";
        }
    },

    acitivtyToPAXMLTimeCode: function(activity) {
        if (!activity)
            return "FR1";
        switch(activity.toLowerCase()) {
            case "sjukdom":
            case "sjukdag":
            case "sjuk":
                return "SJK";
            case "sjukdom karensdag":
            case "sjukdom - karensdag":
                return "SJK_KAR";
            case "sjukdom - sjuklön":
            case "sjukdom sjuklön":
                return "SJK_LÖN";
            case "sjukdom - sjukersättning":
            case "sjukdom sjukersättning":
                return "SJK_ERS";
            case "sjukdom - sjukpenning":
            case "sjukdom sjukpenning":
                return "SJK_PEN";
            case "arbetsskada":
                return "ASK";
            case "havandeskapspenning":
                return "HAV";
            case "föräldraledighet":
                return "FPE";
            case "vård av barn":
                return "VAB";
            case "smittbärare":
                return "SMB";
            case "utbildning":
                return "UTB";
            case "militärtjänst":
                return "MIL";
            case "svenskundervisning för invadrare":
                return "SVE";
            case "närståendevård":
                return "NÄR";
            case "tjänsteledig":
                return "TJL";
            case "semester":
                return "SEM";
            case "semester - betald":
            case "semester betald":
                return "SEM_BET";
            case "semester - sparad":
            case "semester sparad":
                return "SEM_SPA";
            case "semester - obetald":
            case "semester obetald":
                return "SEM_OBE";
            case "semester förskott":
            case "semester - förskott":
                return "SEM_FÖR";
            case "kompledig":
                return "KOM";
            case "permission":
                return "PEM";
            case "permitterad":
                return "PER";
            case "fackligt arbete":
                return "FAC";
            case "arbetstidskonto":
                return "ATK";
            case "kontaktdagar":
                return "KON";
            case "pappaledig":
                return "PAP";
            default:
                return "FR1";
        }
    },

    reportToRows: function(report) {
        var group = null;
        if (report.get('groupId')) {
            if (Core.client && Core.client.groups) {
                group = Core.client.groups.get(report.get('groupId'));
                if (!group) {
                    Core.client.groups.fetchAndCache();
                    group = Core.client.group.get(report.get('groupId'));
                }
            }
        }

        var user = null;
        if (report.get('userId')) {
            if (Core.client && Core.client.users) {
                user = Core.client.users.get(report.get('userId'));
                if (!user) {
                    Core.client.users.fetchAndCache();
                    user = Core.client.users.get(report.get('userId'));
                }
            }
        }

        var vehicle = null;
        if (report.get('vehicleId')) {
            if (Core.client && Core.client.assets) {
                vehicle = Core.client.assets.get(report.get('vehicleId'));
                if (!vehicle) {
                    Core.client.assets.fetchAndCache();
                    vehicle = Core.client.assets.get(report.get('vehicleId'));
                }
            }
        }
        return this.createRowForReport(report, group, user, vehicle);
    },

    createRowForReport: function(report, group, user, vehicle) {
        var extraRows = [];
        var items = [];
        var customFields = [];
        var priceSum = 0;

        if (report.get('items') && report.get('items').length > 0) {
            report.get('items').forEach(function(item) {
                if (item.amount && item.articleUnitPrice) {
                    priceSum += ((item.amount * item.articleUnitPrice) / 100);
                } else if (item.amount && item.unitPrice) {
                    priceSum += ((item.amount * item.unitPrice) / 100);
                }
            });
        }
        report.priceSum = priceSum;

        if (report.get('items') && report.get('items').length > 1) {
            items = report.get('items').slice(1);
        }
        if (report.get('customFields') && report.get('customFields').length > 1) {
            customFields = report.get('customFields').slice(1);
        }

        extraRows = this.generateExtraReportRow(report, items, customFields, []);

        var rows = [];
        rows.push(this.createRowForReportOrExtra(report, group, user, vehicle));
        var self = this;
        extraRows.forEach(function(extraRow) {
            rows.push(self.createRowForReportOrExtra(extraRow));
        });

        return rows;
    },

    generateExtraReportRow: function(report, items, customFields, extraRows) {
        var temp = new WorkReport();
        temp.id = report.id;
        temp.temp = true;
        temp.attributes.workDate = report.get('workDate');

        if (items && items.length <= 0 && customFields && customFields.length <= 0) {
            return extraRows;
        }

        if (items && items.length > 0) {
            temp.attributes.items = [];
            temp.attributes.items.push(items.pop());
        }
        if (customFields && customFields.length > 0) {
            temp.attributes.customFields = [];
            temp.attributes.customFields.push(customFields.pop());
        }

        extraRows.push(temp);
        return this.generateExtraReportRow(report, items, customFields, extraRows);
    },

    createRowForReportOrExtra: function(report, group, user, vehicle) {
        var headerRow = [];
        var dataRow = [];
        
        headerRow.push(i18next.t('reportExcelExportMapping_date'));
        if (report.get('workDate')) {
            var workDate = new Date(report.get('workDate'));
            var dayOfWeek = i18next.t('weekDayArray_' + new Date(workDate).getDay());
            var date = Formatting.datePart(workDate);
            dataRow.push(dayOfWeek + ' ' + date);
        } else {
            dataRow.push('');
        }

        headerRow.push(i18next.t('reportExcelExportMapping_group'));
        dataRow.push(group && group.get('name') ? group.get('name') : '');

        headerRow.push(i18next.t('reportExcelExportMapping_activity'));
        dataRow.push(report.get('activityName') ? report.get('activityName') : '');

        headerRow.push(i18next.t('reportExcelExportMapping_customer'));
        dataRow.push(report.get('customerName') ? report.get('customerName') : '');

        headerRow.push(i18next.t('reportExcelExportMapping_customerProjectNo'));
        var customerProjectNo = report.get('customerProjectNo') || report.get('customerProjectNoText');
        dataRow.push(customerProjectNo ? customerProjectNo : '');

        headerRow.push(i18next.t('reportExcelExportMapping_customerProject'));
        dataRow.push(report.get('customerProjectName') ? report.get('customerProjectName') : '');
        
        headerRow.push(i18next.t('reportExcelExportMapping_title'));
        dataRow.push(report.get('jobTitle') ? report.get('jobTitle') : '');

        headerRow.push(i18next.t('reportExcelExportMapping_job'));
        dataRow.push(report.get('jobNo') ? '#' + report.get('jobNo') : '');

        headerRow.push(i18next.t('reportExcelExportMapping_description'));
        dataRow.push(report.get('description') ? report.get('description') : '');
        
        headerRow.push(i18next.t('reportExcelExportMapping_user'));
        dataRow.push(user && user.shortName() ? user.shortName() : '');
        
        headerRow.push(i18next.t('reportExcelExportMapping_vehicleNo'));
        dataRow.push(vehicle && vehicle.get('assetNo') ? vehicle.get('assetNo') : '');

        headerRow.push(i18next.t('reportExcelExportMapping_vehicle'));
        dataRow.push(vehicle && vehicle.get('name') ? vehicle.get('name') : '');
        headerRow.push(i18next.t('reportExcelExportMapping_date'));
        dataRow.push(report.get('workDate') ? Formatting.datePart(report.get('workDate'), true) : '');
        headerRow.push(i18next.t('reportExcelExportMapping_startTime'));
        dataRow.push(report.get('startTime') ? Formatting.date(report.get('startTime'), report.get('workDate')) : '');
        headerRow.push(i18next.t('reportExcelExportMapping_endTime'));
        dataRow.push(report.get('endTime') ? Formatting.date(report.get('endTime'), report.get('workDate')) : '');
        headerRow.push(i18next.t('reportExcelExportMapping_pauseDuration'));
        dataRow.push(report.get('pauseDuration') ? Formatting.duration(report.get('pauseDuration')) : '');

        if (report.get('items') && report.get('items').length > 0) {
            var article = report.get('items')[0];
            headerRow.push(i18next.t('reportExcelExportMapping_articleNo'));
            dataRow.push(article.articleNo ? article.articleNo : '');

            headerRow.push(i18next.t('reportExcelExportMapping_articleDescription'));
            dataRow.push(article.description ? article.description : '');

            headerRow.push(i18next.t('reportExcelExportMapping_articleAmount'));
            dataRow.push(article.amount ? article.amount : '');

            headerRow.push(i18next.t('reportExcelExportMapping_articleInvoicedAmount'));
            dataRow.push(article.invoicedAmount ? article.invoicedAmount : (article.amount ? article.amount : ''));

            headerRow.push(i18next.t('reportExcelExportMapping_articleUnit'));
            dataRow.push(article.unit ? i18next.t('reportUnitShort_' + article.unit) : '');

            headerRow.push(i18next.t('reportExcelExportMapping_articlePrice'));
            if (article.articleUnitPrice && article.amount) {
                dataRow.push((article.articleUnitPrice * article.amount) / 100);
            } else if (article.unitPrice && article.amount) {
                dataRow.push((article.unitPrice * article.amount) / 100);
            } else {
                dataRow.push('');
            }
        } else {
            headerRow.push(i18next.t('reportExcelExportMapping_articleNo'));
            dataRow.push('');
            headerRow.push(i18next.t('reportExcelExportMapping_articleDescription'));
            dataRow.push('');
            headerRow.push(i18next.t('reportExcelExportMapping_articleAmount'));
            dataRow.push('');
            headerRow.push(i18next.t('reportExcelExportMapping_articleInvoicedAmount'));
            dataRow.push('');
            headerRow.push(i18next.t('reportExcelExportMapping_articleUnit'));
            dataRow.push('');
            headerRow.push(i18next.t('reportExcelExportMapping_articlePrice'));
            dataRow.push('');
        }

        if (report.get('customFields')) {
            headerRow.push(i18next.t('reportExcelExportMapping_customFieldLabel'));
            dataRow.push(report.get('customFields') && report.get('customFields').length > 0 && report.get('customFields')[0] ? report.get('customFields')[0].label : '');
            headerRow.push(i18next.t('reportExcelExportMapping_customFieldValue'));
            dataRow.push(report.get('customFields') && report.get('customFields').length > 0 && report.get('customFields')[0] ? this.parseCustomFieldValue(report.get('customFields')[0].value, report.get('customFields')[0].type) : '');
        } else {
            headerRow.push(i18next.t('reportExcelExportMapping_customFieldLabel'));
            dataRow.push('');
            headerRow.push(i18next.t('reportExcelExportMapping_customFieldValue'));
            dataRow.push('');
        }

        headerRow.push(i18next.t('reportExcelExportMapping_workDuration'));
        dataRow.push(report.get('workDuration') ? report.get('workDuration') / 60 : '');

        headerRow.push(i18next.t('reportExcelExportMapping_invoicedHours'));
        dataRow.push(report.get('invoicedWorkDuration') ? report.get('invoicedWorkDuration') / 60 : '');

        headerRow.push(i18next.t('reportExcelExportMapping_totalPrice'));
        dataRow.push(report.get('totalPrice') ? report.get('totalPrice') / 100 : '');

        return [headerRow, dataRow];
    },

    parseCustomFieldValue: function(value, type) {
        if (type === "DATE") {
            console.log("DATEOSVVVVVVVV", Formatting.datePart(value, true));
            return Formatting.datePart(parseInt(value), true)
        } else if (type === "TIME") {
            return Formatting.time(parseInt(value))
        } else if (type === "DATETIME") {
            return Formatting.date(parseInt(value), true)
        } else {
            return value;
        }
    },

    addChildrenToElement: function(element, children) {
        for (var i = 0; i < children.length; i++) {
            element.appendChild(children[i]);
        }
    },

    addTextToElement: function(xmlDoc, element, text) {
        var tmp = xmlDoc.createTextNode(text);
        element.appendChild(tmp);
    },

    // Visma XML
    reportsToVismaXML: function(reports, users, from, to) {
        var xmlDoc = document.implementation.createDocument(null, "SalaryData");
        var parser = new DOMParser();
        var prolog = '<?xml version="1.0" encoding="ISO-8859-1"?>';
        xmlDoc = prolog + (new XMLSerializer()).serializeToString(xmlDoc);
        xmlDoc = parser.parseFromString(xmlDoc, "application/xml");

        var rootElements = xmlDoc.getElementsByTagName("SalaryData");
        var timeCodes = xmlDoc.createElement("TimeCodes");

        var salaryDataEmployee = xmlDoc.createElement("SalaryDataEmployee");
        salaryDataEmployee.setAttribute('FromDate', from);
        salaryDataEmployee.setAttribute('ToDate', to);

        var regOutlayCodes = xmlDoc.createElement("RegOutlayCodes")

        var employees = {};
        var timeCodesToAdd = [];
        var regOutlayCodesToAdd = [];
        var self = this;

        reports.forEach(function(report){
            var userId = report.get('userId');
            var user = Core.client.users.get(userId);
            var userEmail = user && user.get('emailAddress');
            if (user) {
                var personalId = user.get('personalIdentificationNo');
                if (!personalId) {
                    throw new Error('User: ' + userEmail + ' missing Personal ID number'); // personal identification is required by Visma - "Anställingsnr"
                }
                if (personalId.length > 20) {
                    throw new Error('User: ' + userEmail + "'s Personal ID number " + personalId + " is too long. Up to 20 characters allowed");
                }
                var fullName = user.get('fullName');
                if (!fullName) {
                    throw new Error('User: ' + userEmail + ' missing full name'); // Visma will load with warning if full name is missing. Better throw and error...
                }
                var firstName = fullName.split(' ')[0];
                if (firstName.length > 50) {
                    throw new Error('User: ' + userEmail + "'s first name is too long. Up to 50 characters allowed");
                }
                var lastName = fullName.split(' ').splice(1).join(' ')
                if (lastName.length > 50) {
                    throw new Error('User: ' + userEmail + "'s last name is too long. Up to 50 characters allowed");
                }
                var workDate = Formatting.datePart(new Date(report.get('workDate')), '1970') // 1970 because I wan't the year part too!
            }

            if (userId && !employees[userId]) { // to collect all reported times under one user object
                employees[userId] = {
                    employmentNo: personalId,
                    firstName: firstName,
                    lastName: lastName,
                    fromDate: from,
                    toDate: to,
                    times: [],
                    outlays: []
                }
            }
            if (report && report.get('items') && report.get('items').length > 0) {
                var items = report.get('items');
                var vismaUnits = {"KM":"Kilometer","MONEY":"Kronor","ITEMS":"Styck"}; //Oklart!
                items.forEach(function(item) { // work reports
                    if (!item || !item.unit) return;
                    if (!item.amount) return;
                    if ((item.unit != "HOURS" && !item.workHours) && (["ITEMS","KM","MONEY"].indexOf(item.unit) < 0 && !item.salaryCode)) return;

                    var salaryCode = item.salaryCode ? item.salaryCode : item.articleNo;
                    if (salaryCode && salaryCode.length > 10) {
                        throw new Error('Article number "' + salaryCode + '" is too long. Up to 10 characters allowed for Visma time codes. Report: "'
                        + Formatting.datePart(report.get('workDate')) + ' - '
                        + (report.get('title') ? report.get('title') + ' - ' : '')
                        + (user ? (user.get('userName') ? user.get('userName') : user.get('fullName')) : '')
                        + '"');
                    }
                    if (item.articleDescription.length > 50) {
                        throw new Error('Article description for article "' + salaryCode + '" is too long. Up to 50 characters allowed for Visma time code name.')
                    }
                    
                    if (item.unit == "HOURS" && item.workHours){
                        if (!timeCodesToAdd.includes(salaryCode)) {
                            timeCodesToAdd.push(salaryCode);
                            timeCodes.appendChild(self.addTimeCode(salaryCode, item.articleDescription, xmlDoc, false));
                        }
                        if (userId && employees[userId]) {
                            employees[userId].times.push({
                                dateOfReport: workDate,
                                timeCode: salaryCode,
                                sumOfHours: item.amount
                            });
                        }
                    } else if (item.salaryCode && ["ITEMS","KM","MONEY"].indexOf(item.unit) >= 0) { // articles with these units are "utlägg"
                        if (!regOutlayCodesToAdd.includes(salaryCode)){
                            regOutlayCodesToAdd.push(salaryCode);
                            regOutlayCodes.appendChild(self.addOutLayCode(salaryCode, item.articleDescription, xmlDoc))
                        }
                        if (userId && employees[userId]) {
                            employees[userId].outlays.push({
                                code: salaryCode,
                                outlayCodeName: item.description,
                                dateOfReport: workDate,
                                noOfPrivate: item.unit == "MONEY" ? 1 : item.amount,
                                pricePerUnit: item.unit == "MONEY" ? item.amount : (item.unitPrice ? item.unitPrice / 100 : (item.articleUnitPrice ? item.articleUnitPrice / 100 : null)),
                                unit: vismaUnits[item.unit],
                                internNote: item.description
                            });
                        }
                    }
                });
            } else { // absence reports
                if (report && report.get('activityName') && !timeCodesToAdd.includes(report.get('activityName'))) {
                    var absenceTimeCode = report.get('activityCode') ? report.get('activityCode') : report.get('activityName');
                    var absenceTimeName = report.get('activityName');
                    if (absenceTimeCode && absenceTimeCode.length > 10) {
                        throw new Error('Activity code/name "' + absenceTimeCode + '" is too long. Up to 10 characters allowed. Report: "'
                        + Formatting.datePart(report.get('workDate')) + ' - '
                        + absenceTimeCode + ' - '
                        + (user ? (user.get('userName') ? user.get('userName') : user.get('fullName')) : '')
                        + '"');
                    }
                    if (!timeCodesToAdd.includes(absenceTimeCode)) {
                        timeCodesToAdd.push(absenceTimeCode);
                        timeCodes.appendChild(self.addTimeCode(absenceTimeCode, absenceTimeName, xmlDoc, true));
                    }
                }
                if (userId && employees[userId] && report) {
                    if (!report.get('workDuration')) {
                        throw new Error('Report "'
                        + Formatting.datePart(report.get('workDate')) + ' - '
                        + report.get('activityName') + ' - '
                        + (user ? (user.get('userName') ? user.get('userName') : user.get('fullName')) : '')
                        + ' is missing work hours"');
                    }
                    if (!report.get('activityName')) {
                        throw new Error ('Report "'
                        + Formatting.datePart(report.get('workDate')) + ' - '
                        + (report.get('title') ? report.get('title') + ' - ' : (report.get('jobTitle') ? report.get('jobTitle') + ' - ' : ''))
                        + (user ? (user.get('userName') ? user.get('userName') : user.get('fullName')) : '')
                        + '" is missing activity name or article number for Visma time code');
                    }
                    var hours = report.get('workDuration') / 60;
                    if (hours) {
                        employees[userId].times.push({
                            dateOfReport: workDate,
                            timeCode: absenceTimeCode,
                            sumOfHours: hours
                        });
                    }
                }
            }
        });
        this.addEmployeeAndReports(employees, xmlDoc, salaryDataEmployee);
        rootElements[0].appendChild(timeCodes);
        rootElements[0].appendChild(regOutlayCodes);
        rootElements[0].appendChild(salaryDataEmployee);

        return xmlDoc;
    },

    addTimeCode: function(salaryCode, salaryCodeName, xmlDoc, isAbsence) {
        var timeCode = xmlDoc.createElement("TimeCode");
        if (isAbsence) {
            timeCode.setAttribute('Code', salaryCode);
            timeCode.setAttribute('TimeCodeName', salaryCodeName);
        } else {
            timeCode.setAttribute('Code', salaryCode);
            timeCode.setAttribute('TimeCodeName', salaryCodeName);
        }
        return timeCode;
    },
    addOutLayCode: function(code, outlayCodeName, xmlDoc) {
        var outlayCode = xmlDoc.createElement("RegOutlayCode")
        outlayCode.setAttribute("Code",code)
        outlayCode.setAttribute("RegOutlayCodeName",outlayCodeName)
        return outlayCode
    },
    addEmployeeAndReports: function(employees, xmlDoc, salaryDataEmployee) {
        var self = this;
        Object.keys(employees).forEach(function(userId){
            var user = employees[userId];
            var employee = xmlDoc.createElement('Employee');

            employee.setAttribute('EmploymentNo', user.employmentNo);
            employee.setAttribute('FirstName', user.firstName);
            employee.setAttribute('Name', user.lastName);
            employee.setAttribute('FromDate', user.fromDate);
            employee.setAttribute('ToDate', user.toDate);

            var times = xmlDoc.createElement('Times');
            var outlays = xmlDoc.createElement('RegOutlays');
            var reports = user.times;
            var outlayReports = user.outlays;

            reports.forEach(function(report) {
                var time = xmlDoc.createElement('Time');
                time.setAttribute('DateOfReport', report.dateOfReport);
                time.setAttribute('TimeCode', report.timeCode);
                time.setAttribute('SumOfHours', report.sumOfHours);
                times.appendChild(time);
            });
            outlayReports.forEach(function(outlayReport){
                var outlay = xmlDoc.createElement('RegOutlay');
                outlay.setAttribute('DateOfReport', outlayReport.dateOfReport);
                outlay.setAttribute('OutlayCode', outlayReport.code);
                outlay.setAttribute('OutlayCodeName', outlayReport.outlayCodeName);
                outlay.setAttribute('NoOfPrivate', outlayReport.noOfPrivate);
                outlay.setAttribute('PricePerUnit', outlayReport.pricePerUnit);
                outlay.setAttribute('Unit', outlayReport.unit);
                outlay.setAttribute('InternNote', outlayReport.internNote)
                outlays.append(outlay)
            });
            employee.appendChild(times);
            employee.appendChild(outlays);
            self.addMandatoryFields(employee, xmlDoc); // Elementet är obligatoriskt när TLU-filen innehåller tidsregistreringar"...
            salaryDataEmployee.appendChild(employee);
        })
    },

    addMandatoryFields: function(element, xmlDoc) { //  but we done have to fill it with data...or?
        var normalWorkingTimes = xmlDoc.createElement('NormalWorkingTimes');
        element.appendChild(normalWorkingTimes);

        var timeAdjustments = xmlDoc.createElement('TimeAdjustments');
        element.appendChild(timeAdjustments);

        var timeBalances = xmlDoc.createElement('TimeBalances'); // documentation a bit unclear wether this element needs to contain "TimeCode" and "ConvAccRegHours"
        var timeBalance = xmlDoc.createElement('TimeBalance');
        timeBalance.setAttribute('TimeCode', '##SumComp##');
        timeBalance.setAttribute('ConvAccRegHours', '0.00');
        timeBalances.appendChild(timeBalance);
        element.appendChild(timeBalances);

        //var regOutlays = xmlDoc.createElement('RegOutlays'); // element for "utlägg"
        //element.appendChild(regOutlays);
    }
}